<iframe [src]="url | safe: 'resourceUrl'"
        title='externalUrl'
        width="100%"
        height="100%"></iframe>
<button class="btn close waves-effect waves-primary"
        (click)="close()">
  {{ 'EXTERNAL_URL.CLOSE' | translate }}
</button>
